var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", [
        _vm._v(
          _vm._s(
            _vm.$t("delegation.form.bookingAndInvoices.listOfAttachedBookings")
          )
        )
      ]),
      _vm.bookings.length === 0
        ? _c("span", [
            _vm._v(
              _vm._s(
                _vm.$t("delegation.form.bookingAndInvoices.noAttachedBooking")
              )
            )
          ])
        : _vm._e(),
      _vm._l(_vm.bookings, function(item) {
        return _c(
          "div",
          { key: item.id },
          [
            _c(
              "v-card",
              [
                _c(
                  "v-card-text",
                  [
                    _c(
                      "v-row",
                      { staticClass: "text-no-wrap" },
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "8" } },
                          [
                            _c(
                              "v-row",
                              [
                                _c(
                                  "v-col",
                                  {
                                    staticStyle: {
                                      "min-width": "40px",
                                      "max-width": "50px"
                                    },
                                    attrs: { cols: "1" }
                                  },
                                  [
                                    item.type.toLowerCase().includes("rail")
                                      ? _c(
                                          "v-tooltip",
                                          {
                                            attrs: { top: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    return [
                                                      _c(
                                                        "v-icon",
                                                        _vm._g(
                                                          {
                                                            attrs: {
                                                              "x-large": ""
                                                            }
                                                          },
                                                          on
                                                        ),
                                                        [
                                                          _vm._v(
                                                            " directions_transit "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "delegation.form.bookingAndInvoices.railBooking"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      : item.type
                                          .toLowerCase()
                                          .includes("hotel")
                                      ? _c(
                                          "v-tooltip",
                                          {
                                            attrs: { top: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    return [
                                                      _c(
                                                        "v-icon",
                                                        _vm._g(
                                                          {
                                                            attrs: {
                                                              "x-large": ""
                                                            }
                                                          },
                                                          on
                                                        ),
                                                        [_vm._v(" hotel ")]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "delegation.form.bookingAndInvoices.hotelBooking"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      : item.type
                                          .toLowerCase()
                                          .includes("flight") ||
                                        item.type.toLowerCase().includes("lcc")
                                      ? _c(
                                          "v-tooltip",
                                          {
                                            attrs: { top: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    return [
                                                      _c(
                                                        "v-icon",
                                                        _vm._g(
                                                          {
                                                            attrs: {
                                                              "x-large": ""
                                                            }
                                                          },
                                                          on
                                                        ),
                                                        [_vm._v(" flight ")]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "delegation.form.bookingAndInvoices.flightBooking"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "v-tooltip",
                                          {
                                            attrs: { top: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    return [
                                                      _c(
                                                        "v-icon",
                                                        _vm._g(
                                                          {
                                                            attrs: {
                                                              "x-large": ""
                                                            }
                                                          },
                                                          on
                                                        ),
                                                        [
                                                          _vm._v(
                                                            " fa-list-alt "
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "delegation.form.bookingAndInvoices.otherBooking"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                  ],
                                  1
                                ),
                                _c("v-col", { attrs: { cols: "11" } }, [
                                  _c(
                                    "strong",
                                    {
                                      staticStyle: { "word-wrap": "break-word" }
                                    },
                                    [_vm._v(_vm._s(item.name))]
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "delegation.form.bookingAndInvoices.reservationNumber"
                                      )
                                    ) + ": "
                                  ),
                                  _c("b", [
                                    _vm._v(_vm._s(item.reservation_number))
                                  ])
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c("v-spacer"),
                        item.invoice_gross_value !== null ||
                        item.total_amount !== null
                          ? _c(
                              "v-col",
                              {
                                staticStyle: { "white-space": "nowrap" },
                                attrs: { cols: "3" }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "delegation.form.bookingAndInvoices.totalAmount"
                                      )
                                    ) +
                                    ": "
                                ),
                                _c(
                                  "span",
                                  { staticClass: "datatable-total-amount" },
                                  [
                                    item.invoice_gross_value !== null
                                      ? [
                                          _vm._v(
                                            _vm._s(item.invoice_gross_value) +
                                              " " +
                                              _vm._s(item.invoice_currency)
                                          )
                                        ]
                                      : [
                                          _vm._v(
                                            _vm._s(item.total_amount) + " PLN"
                                          )
                                        ]
                                  ],
                                  2
                                ),
                                _c("br"),
                                _c(
                                  "span",
                                  { staticStyle: { "font-size": "x-small" } },
                                  [
                                    item.invoice_gross_value !== null
                                      ? [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.$t(
                                                  "delegation.form.bookingAndInvoices.invoiceAvailable"
                                                )
                                              ) +
                                              ")"
                                          )
                                        ]
                                      : [
                                          _vm._v(
                                            "(" +
                                              _vm._s(
                                                _vm.$t(
                                                  "delegation.form.bookingAndInvoices.waitingForInvoice"
                                                )
                                              ) +
                                              ")"
                                          )
                                        ]
                                  ],
                                  2
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { top: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            staticClass: "py-5",
                                            attrs: {
                                              disabled:
                                                _vm.canBeRemoved(item) ===
                                                  false ||
                                                _vm.$store.getters[
                                                  "Ajax/loading"
                                                ],
                                              icon: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.removeBooking(item)
                                              }
                                            }
                                          },
                                          on
                                        ),
                                        [_c("v-icon", [_vm._v("close")])],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.canBeRemoved(item) === false
                                    ? _vm.$t(
                                        "delegation.form.bookingAndInvoices.bookingAlreadyAttachedAsTravelPart"
                                      )
                                    : _vm.$t(
                                        "delegation.form.bookingAndInvoices.removeAttachedBooking"
                                      )
                                ) +
                                " "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      }),
      !_vm.readonly
        ? _c(
            "ajax-booking-general-select",
            { on: { selectedBooking: _vm.addBooking } },
            [
              _c("v-btn", { staticClass: "primary my-3" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("delegation.form.bookingAndInvoices.attachBooking")
                  )
                )
              ])
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }